import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=50db5d56&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50db5d56')) {
      api.createRecord('50db5d56', component.options)
    } else {
      api.reload('50db5d56', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=50db5d56&", function () {
      api.rerender('50db5d56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yQIi04pO0KJp/JS/videoIframe.vue"
export default component.exports